import { render, staticRenderFns } from "./corpSales.vue?vue&type=template&id=626e0922&"
import script from "./corpSales.vue?vue&type=script&lang=js&"
export * from "./corpSales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports